export function setDevicePayload(payload) {
    return {
        type: "ADD_DEVICE_DEVICE",
        device: {
            name: payload.name,
            serial_number: payload.serial_number
        }
    }
}

export function setDeviceTagCategory(payload) {
    return {
        type: "ADD_DEVICE_TAG_CAT",
        device: {
            tag_cat: payload
        }
    }
}

export function setDeviceTag(payload) {
    return {
        type: "ADD_DEVICE_TAG",
        device: {
            tags: payload
        }
    }
}

export function setRoleInfo(payload) {
    return {
        type: "ADD_ROLE_INFO",
        role: {
            name: payload.name,
            description: payload.description,
            permissions: payload.permissions
        }
    }
}

export function setRoleAccess(payload) {
    return {
        type: "ADD_ROLE_ACCESS",
        role: {
            navs: payload.navs,
            navsObj: payload.navsObj,
            descendant: payload.descendant
        }
    }
}

export function setEditRoleDirect(payload) {
    return {
        type: "EDIT_ROLE_DIRECT",
        role: {
            direct: payload
        }
    }
}

export function setDeviceCategoryPayload(payload) {
    return {
        type: "ADD_DEVICE_CATEGORY",
        device: {
            category: payload.category,
            type: payload.type
        }
    }
}

export function setAppNamePayload(payload) {
    return {
        type: "SET_APP_NAME",
        application: {
            title: payload.title,
        }
    }
}

export function setDeviceEmpty() {
    return {
        type: "SET_DEVICE_EMPTY",
        device: {
        }
    }
}

export function setRoleEmpty() {
    return {
        type: "SET_ROLE_EMPTY",
        role: {
        }
    }
}

export function setKeyDate(payload) {
    return {
        type: "SET_KEY_DATE",
        key: {
            date: payload.date
        }
    }
}

export function setKeyDateEmpty() {
    return {
        type: "SET_KEY_DATE_EMPTY",
        key: {
        }
    }
}

export function setDeviceConfigPayload(payload) {
    return {
        type: "ADD_DEVICE_CONFIG",
        device: {
            sensors: payload.sensors,
        }
    }
}

export function setDeviceLoraPayload(payload) {
    return {
        type: "ADD_DEVICE_LORA",
        device: {
            dev_eui: payload.dev_eui,
            otaa_key: payload.otaa_key,
            network_server_id: payload.network_server_id,
        }
    }
}

export function setDeviceZlanPayload(payload) {
    return {
        type: "ADD_DEVICE_ZLAN",
        device: {
            dev_uid: payload.dev_uid,
        }
    }
}

export function setDeviceUSRIotPayload(payload) {
    return {
        type: "ADD_DEVICE_USRIOT",
        device: {
            dev_uid: payload.dev_uid,
        }
    }
}

export function setDeviceBivocomPayload(payload) {
    return {
        type: "ADD_DEVICE_BIVOCOM",
        device: {
            dev_uid: payload.dev_uid,
        }
    }
}

export function setDeviceFriendcomPayload(payload) {
    return {
        type: "ADD_DEVICE_FRIENDCOM",
        device: {
            dev_uid: payload.dev_uid,
        }
    }
}